import {doFetch} from "vimmi-web-utils/cjs/doFetch";
import Config from "./config";
import {formatDate} from "vimmi-web-utils/cjs/formatDate";

export class Epg {
  async getByChannels(cIds) {
    let date = new Date();
    return doFetch(`https://${Config.get('backend')}/epg/`, {
      query: {
        start_date: formatDate(date, 'yyyy-MM-dd'),
        end_date: formatDate(date, 'yyyy-MM-dd'),
        // start_time: formatDate(date, 'hh-mm-ss'),
        // end_time: formatDate(date + (((24 - date.getHours()) || 24) * 60 * 60 * 1000), 'hh-mm-ss'), //to get to end of the day
        items: cIds,
        d: 'web'
      }
    }).then((res) => {
      return res.items.map((item) => {
        let st = item.start.split(':');
        item.start = st[0] + ':' + st[1];
        let end = item.end.split(':');
        item.end = end[0] + ':' + end[1];
        return item;
      });
    })
  }

  isActive(item) {
    let start = new Date(item.date + 'T' + item.start + ':00');
    let end = new Date(item.date_end + 'T' + item.end + ':00');
    return start < Date.now() && Date.now() < end;
  }

  getActiveEpg(epgList) {
    return epgList.find((item) => {
      return this.isActive(item)
    })
  }

  filter(epgList) {
    return epgList.filter((item) => {
      let end = new Date(item.date_end + 'T' + item.end + ':00');
      return Date.now() < end;
    })
  }
}

const epgSrv = new Epg();
export default epgSrv;
